// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3ew4Y","list":"BalanceDue_list__1Ln2P","listRow":"BalanceDue_listRow__3tVs3","total":"BalanceDue_total__1_qMf"};